import React from 'react';
import { motion } from 'framer-motion';
import {
  ChevronUpIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';

const DirectionalArrow = ({ direction, count, mapRef }) => {
  if (count === 0) return null;

  const icons = {
    north: ChevronUpIcon,
    south: ChevronDownIcon,
    east: ChevronRightIcon,
    west: ChevronLeftIcon
  };

  const positions = {
    north: { top: '140px', left: '50%', transform: 'translateX(-50%)' },
    south: { bottom: '180px', left: '50%', transform: 'translateX(-50%)' },
    east: { right: '20px', top: '50%', transform: 'translateY(-50%)' },
    west: { left: '20px', top: '50%', transform: 'translateY(-50%)' }
  };

  const animations = {
    north: { initial: { opacity: 0, y: -10 }, animate: { opacity: 1, y: 0 } },
    south: { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 } },
    east: { initial: { opacity: 0, x: 10 }, animate: { opacity: 1, x: 0 } },
    west: { initial: { opacity: 0, x: -10 }, animate: { opacity: 1, x: 0 } }
  };

  const movements = {
    north: [0, -200],
    south: [0, 200],
    east: [200, 0],
    west: [-200, 0]
  };

  const Icon = icons[direction];
  const { initial, animate } = animations[direction];

  const handleClick = () => {
    const map = mapRef.current?.getMap();
    if (map) map.panBy(movements[direction], { duration: 300 });
  };

  return (
    <motion.button
      initial={initial}
      animate={animate}
      onClick={handleClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      style={{
        position: 'absolute',
        ...positions[direction],
        backgroundColor: 'rgba(245, 147, 61, 0.95)',
        backdropFilter: 'blur(8px)',
        borderRadius: '20px',
        padding: '6px 14px',
        border: 'none',
        cursor: 'pointer',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
      }}
    >
      <Icon style={{ width: 14, height: 14, color: 'white' }} />
      <span style={{ color: 'white', fontSize: '12px', fontWeight: 600 }}>
        {count}
      </span>
    </motion.button>
  );
};

export default DirectionalArrow;
